import { render, staticRenderFns } from "./SelectApprover.vue?vue&type=template&id=c57dae7a&"
import script from "./SelectApprover.vue?vue&type=script&lang=js&"
export * from "./SelectApprover.vue?vue&type=script&lang=js&"
import style0 from "./SelectApprover.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports